<template>
  <aside class="sidebar" :class="{ collapsed, 'mobile-open': mobileOpen }">
    <div class="sidebar-brand">
      <BrandMark />
      <div v-if="!collapsed" class="brand-copy">
        <strong>SafetyVision</strong>
        <span>安全视野学习平台</span>
      </div>
    </div>

    <nav class="sidebar-nav" aria-label="主导航">
      <RouterLink v-for="item in navItems" :key="item.to" :to="item.to" :title="collapsed ? item.label : ''" @click="$emit('navigate')">
        <component :is="item.icon" :size="19" stroke-width="1.8" />
        <span v-if="!collapsed">{{ item.label }}</span>
        <i v-if="item.badge && !collapsed">{{ item.badge }}</i>
      </RouterLink>
    </nav>

    <div v-if="!collapsed" class="sidebar-promo border-beam-card">
      <div class="promo-orb"><Sparkles :size="18" /></div>
      <strong>让知识看得见</strong>
      <p>题库、资料与 AI 工具，在一个工作台高效协同。</p>
      <RouterLink to="/membership">查看会员权益 <ArrowUpRight :size="14" /></RouterLink>
    </div>

    <button class="sidebar-toggle" type="button" @click="$emit('toggle')">
      <PanelLeftClose v-if="!collapsed" :size="18" />
      <PanelLeftOpen v-else :size="18" />
      <span v-if="!collapsed">收起导航</span>
    </button>
  </aside>
</template>

<script setup>
import { ArrowUpRight, BookOpen, Bot, House, LibraryBig, PanelLeftClose, PanelLeftOpen, Sparkles, UserRound } from "lucide-vue-next";
import BrandMark from "./BrandMark.vue";

defineProps({ collapsed: Boolean, mobileOpen: Boolean });
defineEmits(["toggle", "navigate"]);

const navItems = [
  { to: "/", label: "学习概览", icon: House },
  { to: "/exams", label: "真题题库", icon: BookOpen },
  { to: "/library", label: "资料库", icon: LibraryBig, badge: "NEW" },
  { to: "/tools", label: "AI 与工具", icon: Bot },
  { to: "/membership", label: "会员权益", icon: UserRound },
];
</script>
